import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "3 8 7 12 3 16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "11", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "11", y1: "6", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "11", y1: "18", y2: "18", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Indent";
const Indent = memo(themed(Icon));
export {
  Indent
};
//# sourceMappingURL=indent.js.map
